import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { Box, IconButton, useMediaQuery } from '@mui/material';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import CustomButton from '../../../components/CustomButton';
import { buttonBgColor, tabBgColor } from '../../../utils/themeColor';
import useIsSmallMobile from '../../../custom-hooks/useIsSmallMobile';

const slides = [
  'Self Checkout',
  'E Commerce',
  'Robots',
  'Delivery',
  'Pickup',
  'App Experience',
  'Restocking',
  'Local Offerings',
];

const CustomSlider = ({ onClickPredefinedTag }) => {
  const isMobile = useMediaQuery('(max-width:500px)');
  const isSmMobile = useIsSmallMobile();
  const containerRef = useRef(null);

  const scroll = (direction) => {
    const container = containerRef.current;
    if (!container) return;

    const scrollAmount = isMobile ? container.offsetWidth : container.offsetWidth / 2;
    const maxScrollLeft = container.scrollWidth - container.clientWidth;

    const newScrollX =
      direction === 'left'
        ? Math.max(0, container.scrollLeft - scrollAmount)
        : Math.min(container.scrollLeft + scrollAmount, maxScrollLeft);

    container.scrollTo({ left: newScrollX, behavior: 'smooth' });
  };

  return (
    <Box
      sx={{
        position: 'relative',
        width: { xs: isSmMobile ? '320px' : '380px', sm: '100%' },
        overflow: 'hidden',
        mx: 'auto',
      }}
    >
      <IconButton
        onClick={() => scroll('left')}
        sx={{
          position: 'absolute',
          top: '50%',
          left: { xs: isSmMobile ? -20 : -15, sm: 5 },
          zIndex: 2,
          transform: 'translateY(-50%)',
          color: tabBgColor,
          p: 0,
        }}
      >
        <ArrowLeftIcon sx={{ fontSize: { xs: '64px', sm: '48px' } }} />
      </IconButton>

      <Box
        ref={containerRef}
        sx={{
          display: 'flex',
          overflowX: 'auto',
          scrollBehavior: 'smooth',
          gap: { xs: isSmMobile ? 2 : 2.2, sm: 1.8 },
          py: 1,
          px: { xs: 1, sm: 0 },
          mx: isSmMobile ? 2.8 : 6,
          '&::-webkit-scrollbar': { display: 'none' },
        }}
      >
        {slides.map((text, index) => (
          <Box key={index} sx={{ flex: '0 0 auto' }}>
            <CustomButton
              sx={{
                fontSize: { xs: isSmMobile ? '10px' : '0.63em', sm: '11.5px' },
                backgroundColor: buttonBgColor,
                color: '#fff',
                py: 0.5,
                px: 1,
                borderRadius: '25px',
                fontWeight: 400,
                textTransform: 'capitalize',
              }}
              onClick={() => onClickPredefinedTag(text)}
            >
              {text}
            </CustomButton>
          </Box>
        ))}
      </Box>

      <IconButton
        onClick={() => scroll('right')}
        sx={{
          position: 'absolute',
          top: '50%',
          right: { xs: isSmMobile ? -20 : -15, sm: 5 },
          zIndex: 2,
          transform: 'translateY(-50%)',
          color: tabBgColor,
          p: 0,
        }}
      >
        <ArrowRightIcon sx={{ fontSize: { xs: '64px', sm: '48px' } }} />
      </IconButton>
    </Box>
  );
};

// Add prop-types validation
CustomSlider.propTypes = {
  onClickPredefinedTag: PropTypes.func.isRequired,
};

export default CustomSlider;
